import { apiUrl } from "../config";

export async function fetchUserConnectStatus({ accountId, initData = "", signal } = {}) {
  const nearWallet = String(accountId || "").trim();
  if (!nearWallet) {
    throw new Error("near_wallet required");
  }

  const response = await fetch(apiUrl("users/connect-status"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      near_wallet: nearWallet,
      init_data: String(initData || ""),
    }),
    signal,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `connect status failed: ${response.status}`);
  }
  return payload;
}
